var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d_foot"},[_c('div',[_vm._v("版权所有：复旦大学管理学院")])])}]

export { render, staticRenderFns }